const prefix = 'TRACKER_'

export const LOADED = `${prefix}LOADED`

export const DATALAYER = {
  UPDATED: `${prefix}DATALAYER_UPDATED`
}

export const TRIGGER = {
  ACTION: `${prefix}TRIGGER_ACTION`,
  VIEW: `${prefix}TRIGGER_VIEW_END`,
  VIEW_END: `${prefix}TRIGGER_VIEW_END`,
  VIEW_START: `${prefix}TRIGGER_VIEW_START`
}